import UploadsManager from '../../layout/admin/UploadManager';

export default function Uploads() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <UploadsManager />
      </div>
    </>
  );
}
